import { idGenerator } from "helpers/createId"
import { constructComponent } from "views/form-generator/constructComponent"
import { formGeneratorTypes } from "./formGeneratorTypes"

const {
  ADD_INPUT,
  EDIT_INPUT,
  DEL_INPUT,
  SELECT_INPUT,
  CLEAN_SELECT_INPUT,
} = formGeneratorTypes

const initialState = {
  inputs: [],
  inputSelect: {}
}

export const formGeneratorReducer = ( state = initialState, { type, payload } ) => {
  switch (type) {
    case ADD_INPUT:
      const newInput = {
        id: idGenerator(),
        script: payload.split(' ').filter(word => word.length > 0 ).join(' '),
        input: constructComponent(payload),
        isSelected: false,
      }
    return {
      ...state,
      inputs: [...state.inputs, newInput],
    }
    
  case EDIT_INPUT: 
  const inputEdited = {
      ...payload,
      input: constructComponent(payload.script),
      isSelected: false
    }
    return {
      ...state,
      inputs: state.inputs.map(input => input.id === payload.id ? inputEdited : input),
      inputSelect: {},
    }

  case DEL_INPUT:
    return {
      ...state,
      inputs: state.inputs.filter(input => input.id !== payload)
    }

  case SELECT_INPUT:
    const selectComponent = state.inputs.map(input => {
      return {
        ...input,
        isSelected: input.id === payload ? true : false
      }
    })
    return {
      ...state,
      inputs: selectComponent,
      inputSelect: selectComponent.find(input => input.id === payload)
    }

  case CLEAN_SELECT_INPUT:
    return {
      ...state,
      inputSelect: {}
    }
  
  
    default:
      return state
  }
}